export default __webpack_public_path__ + "images/YW.b634c4a.png";